import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { VERTICAL_NAV_LOADED } from '../../constants/metrics';
import initializeUsageTrackers from '../../deferred/analytics/initializeUsageTrackers';
import hydrateStore from '../../reducers/utils/hydrateStore';
import { configureStore } from '../../utils/configureStore';
import { setLangKey } from '../../utils/getLangKey';
import { addRootNavContainer, getOrAddUtilityBannersContainer } from '../../utils/globalToolbarUtils';
import loadDependentScripts from '../../utils/loadDependentScripts';
import { Metrics } from '../../utils/metrics';
import { getNavStartTime } from '../../utils/navStartTime';
import setupStickyToolbar from '../../utils/redesignedNavHacks/setupStickyToolbar';
import { RootNav } from '../components/RootNav';
import { getNavEl } from '../../utils/getNavEl';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../constants/logging';
import { jsx as _jsx } from "react/jsx-runtime";
export const renderRootNav = (callback, resp) => {
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  const {
    translations,
    user,
    portal
  } = resp;
  const {
    email: userEmail,
    scopes,
    displayLanguage
  } = user;
  const {
    gates
  } = portal;
  const store = configureStore(hydrateStore(resp));
  const navStartTime = getNavStartTime();
  if (navStartTime !== undefined) {
    Metrics.timer(VERTICAL_NAV_LOADED).update(performance.now() - navStartTime);
  }
  setLangKey(displayLanguage);
  translations['LANG_FROM_NAVCONFIG'] = displayLanguage;
  initializeUsageTrackers({
    userEmail,
    navType: store.getState().appConfig.navType
  });
  getOrAddUtilityBannersContainer();
  setupStickyToolbar(getNavEl());
  const container = addRootNavContainer();
  const root = createRoot(container);
  root.render( /*#__PURE__*/_jsx(ThemeProvider, {
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(RootNav, {})
    })
  }));
  loadDependentScripts(scopes, gates);
  callback(store);
  import( /* WebpackChunkName: "nav-deferred" */'unified-navigation-ui/NavDeferred').then(mod => mod.default).then(NavDeferred => {
    new NavDeferred().start();
  }).catch(error => {
    logger.error(new Error('Failed to load NavDeferred', {
      cause: error
    }));
  });
};